/**
 * 富文本编辑器全局配置
 * @param {string} readOnly
 */
const editorOptionConfig = (readOnly?: string) => {
  if (readOnly !== 'readOnly') {
    return {
      placeholder: '请输入内容',
      theme: 'snow', // 主题
      modules: {
        // toolbar工具栏的工具选项（默认展示全部）
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // 文字样式
          [{ align: [] }], // 对齐方式
          [{ color: [] }, { background: [] }], // 前景色和背景色
          [{ size: ['small', false, 'large', 'huge'] }], // 文字大小
          [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
          ['clean'], // 清除格式
          // ['link', 'image', 'video'], // 超链接， 图片，和视频
          ['link', 'image'], // 超链接， 图片
        ],
        imageDrop: false, // 图片可拖入
        imageResize: {
          // 调整大小组件。
          displayStyles: {
            backgroundColor: 'black',
            border: 'none',
            color: 'white',
          },
          modules: ['Resize', 'DisplaySize', 'Toolbar'],
        },
      },
    };
  } else {
    // 只读状态
    return {
      placeholder: '请输入内容',
      theme: 'snow', // 主题
      readOnly: true,
      modules: {
        // toolbar工具栏的工具选项（默认展示全部）
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // 文字样式
          [{ align: [] }], // 对齐方式
          [{ color: [] }, { background: [] }], // 前景色和背景色
          [{ size: ['small', false, 'large', 'huge'] }], // 文字大小
          [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
          ['clean'], // 清除格式
          ['link', 'image'], // 超链接， 图片
          // ['link', 'image', 'video'], // 超链接， 图片，和视频
        ],
      },
    };
  }
};

export default editorOptionConfig;
